<template>
    <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible">
        <el-form :model="obj"
                 ref="addEditForm" status-icon
                 :rules="rules"> <!--:rules="rulesUser"-->
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item prop="startDate">
                        <el-date-picker
                                v-model="obj.startDate"
                                type="date"
                                class="w-full"
                                placeholder="Start datum">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item prop="endDate">
                        <el-date-picker
                                v-model="obj.endDate"
                                type="date"
                                class="w-full"
                                placeholder="Eind datum">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <!-- Footer -->
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">Annuleer</el-button>
            <el-button type="primary" @click="submitForm('addEditForm')" :loading="loading" :disabled="exportDone">Exporteren</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import moment from 'moment'
    import axios from 'axios'
    export default {
        name: "EnrollmentExportDialog",
        data() {
            return {
                dialogTitle: "Inschrijvigen Exporteren",
                dialogVisible: false,
                obj: {
                    startDate: null,
                    endDate: null
                },
                loading: false,
                exportDone: false,

                // Rules
                rules: {
                    startDate: [
                        {required: true, message: 'Selecteer een start datum.', trigger: 'blur'}
                    ],
                    endDate: [
                        {required: true, message: 'Selecteer ee eind datum.', trigger: 'blur'}
                    ],
                }
            }
        },
        methods: {
            show() {
                this.dialogVisible = true
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.createExport()
                    }
                });
            },
            createExport() {
                const that = this
                this.loading = true
                axios({
                    method: 'post',
                    url: `admin/enrollments/export?startDate=${that.getInterval.firstDay}&endDate=${that.getInterval.lastDay}`,
                    responseType: 'arraybuffer',
                    data: {
                        firstName: 'dummy'
                    },
                }).then(function(response) {
                    that.loading = false
                    that.exportDone = true
                    let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = 'inschrijvingen.xlsx'
                    link.click()
                    that.$notify({
                        title: `Export sucessvol!`,
                        message: `Inschrijvingslijst werd succesvol geëxporteerd, het bestand is terug te vinden in de downloads.`,
                        type: 'success'
                    });
                }).catch(function(error) {
                    that.$message({
                        showClose: true,
                        message: "Oops! Er ging iets mis, probeer later opnieuw.",
                        type: "error"
                    });
                    console.log(error)
                })
            },
        },
        computed: {
            getInterval() {
                let firstDay = moment(this.obj.startDate).format("D-MM-YYYY")
                let lastDay = moment(this.obj.endDate).format("D-MM-YYYY")

                return {
                    firstDay: firstDay,
                    lastDay: lastDay
                };
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/dashboard/enrollments/dialogs/EnrollmentExportDialog.vue